module.exports = __webpack_public_path__ + "h5/img/set.15bcc560.png";